module.exports = __webpack_public_path__ + "a30df271585049885e4548b10f882267.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/containers/Help/screenshots/Wizard Page (5).png
// module id = 1048
// module chunks = 0